// Add to Cart functionality
document.addEventListener('DOMContentLoaded', function() {
  const addToCartForms = document.querySelectorAll('form[action*="/cart/add"]');
  
  addToCartForms.forEach(function(form) {
    form.addEventListener('submit', function(e) {
      // Check if AJAX cart is preferred (you can toggle this)
      const useAjax = false; // Set to false to use standard form submission
      
      if (!useAjax) {
        // Let the form submit normally
        return true;
      }
      
      // AJAX submission (currently disabled)
      e.preventDefault();
      
      const formData = new FormData(form);
      const submitButton = form.querySelector('button[type="submit"]');
      const originalText = submitButton.textContent;
      
      // Disable button and show loading state
      submitButton.disabled = true;
      submitButton.textContent = 'Adding...';
      
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(data => {
        console.log('Item added:', data);
        // Update cart count
        return fetch('/cart.js');
      })
      .then(response => response.json())
      .then(cart => {
        console.log('Cart:', cart);
        // Update cart quantity badge
        const cartQuantityElements = document.querySelectorAll('.cart-quantity');
        cartQuantityElements.forEach(function(element) {
          element.textContent = cart.item_count;
        });
        
        // Show success message
        submitButton.textContent = 'Added!';
        
        // Redirect to cart page after 1 second
        setTimeout(function() {
          window.location.href = '/cart';
        }, 1000);
      })
      .catch(error => {
        console.error('Error:', error);
        submitButton.disabled = false;
        submitButton.textContent = 'Error - Try Again';
        
        setTimeout(function() {
          submitButton.textContent = originalText;
        }, 2000);
      });
    });
  });
});

